import { useEffect, useRef } from "react";
import { Bold, Italic, Underline, List, RemoveFormatting } from "lucide-react";

const SIZES = [
  { label: "Small", value: "2" },
  { label: "Normal", value: "3" },
  { label: "Large", value: "5" },
  { label: "Heading", value: "6" },
];

export const RichTextEditor = ({ value, onChange, placeholder, testId }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd, arg) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current?.innerHTML || "");
  };

  const btn = "p-1.5 rounded text-white/60 hover:text-[color:var(--ufr-green)] hover:bg-white/5 transition-colors";

  return (
    <div className="border border-white/10 rounded-md bg-black/40 overflow-hidden">
      <div className="flex items-center gap-1 px-2 py-1.5 border-b border-white/10 bg-white/[0.03] flex-wrap">
        <select
          className="bg-transparent text-white/70 text-xs border border-white/10 rounded px-1.5 py-1 mr-1 focus:outline-none [&>option]:bg-black"
          defaultValue="3"
          onChange={(e) => exec("fontSize", e.target.value)}
          data-testid="rte-size-select"
        >
          {SIZES.map((s) => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
        <button type="button" className={btn} onMouseDown={(e) => { e.preventDefault(); exec("bold"); }} title="Bold" data-testid="rte-bold-btn"><Bold size={14} /></button>
        <button type="button" className={btn} onMouseDown={(e) => { e.preventDefault(); exec("italic"); }} title="Italic" data-testid="rte-italic-btn"><Italic size={14} /></button>
        <button type="button" className={btn} onMouseDown={(e) => { e.preventDefault(); exec("underline"); }} title="Underline" data-testid="rte-underline-btn"><Underline size={14} /></button>
        <button type="button" className={btn} onMouseDown={(e) => { e.preventDefault(); exec("insertUnorderedList"); }} title="Bullet list" data-testid="rte-list-btn"><List size={14} /></button>
        <button type="button" className={btn} onMouseDown={(e) => { e.preventDefault(); exec("removeFormat"); }} title="Clear formatting" data-testid="rte-clear-btn"><RemoveFormatting size={14} /></button>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={() => onChange(ref.current?.innerHTML || "")}
        className="min-h-[130px] max-h-[320px] overflow-y-auto px-4 py-3 text-sm text-white/85 focus:outline-none [&_ul]:list-disc [&_ul]:pl-5 empty:before:content-[attr(data-placeholder)] empty:before:text-white/30"
        data-placeholder={placeholder}
        data-testid={testId || "rich-text-editor"}
      />
    </div>
  );
};
